// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__3EcxE","image":"App_image__1QcQR"};